import { fileTouchTimeout } from 'analyse2/config'

const fileTouchHasTimedOut = fileOverview => {
  const { touched } = fileOverview
  if (!touched) return true
  else if (Date.now() - touched > fileTouchTimeout) return true
  else return false
}

export default fileTouchHasTimedOut